export const getInvitationToken = (): string | undefined => {
  if (typeof window === 'undefined') return undefined;

  const params = new URLSearchParams(window.location.search);
  const token = params.get('invitation');

  console.log(`Extracted invitation token: ${token}`);

  return token || undefined;
};
